// These helper functions are pulled
// from Segment's open source code
export function pageDefaults() {
    const referrer = document.referrer;
    // try catch ensures that the string is a valid URL
    try {
        const refUrl = new URL(referrer);
        return {
            referrer,
            referrerHost: refUrl.host,
            referrerPath: refUrl.pathname,
            referrerSearch: refUrl.search,
        };
    }
    catch (_a) {
        return { referrer };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVmZXJyZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY2RwL2NvbnRleHQvcmVmZXJyZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsb0NBQW9DO0FBQ3BDLGtDQUFrQztBQVNsQyxNQUFNLFVBQVUsWUFBWTtJQUMxQixNQUFNLFFBQVEsR0FBVyxRQUFRLENBQUMsUUFBUSxDQUFDO0lBQzNDLG1EQUFtRDtJQUNuRCxJQUFJLENBQUM7UUFDSCxNQUFNLE1BQU0sR0FBUSxJQUFJLEdBQUcsQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUN0QyxPQUFPO1lBQ0wsUUFBUTtZQUNSLFlBQVksRUFBRSxNQUFNLENBQUMsSUFBSTtZQUN6QixZQUFZLEVBQUUsTUFBTSxDQUFDLFFBQVE7WUFDN0IsY0FBYyxFQUFFLE1BQU0sQ0FBQyxNQUFNO1NBQzlCLENBQUM7SUFDSixDQUFDO0lBQUMsV0FBTSxDQUFDO1FBQ1AsT0FBTyxFQUFFLFFBQVEsRUFBRSxDQUFDO0lBQ3RCLENBQUM7QUFDSCxDQUFDIn0=